import { render, staticRenderFns } from "./listaDDT.vue?vue&type=template&id=68075ad2"
import script from "./listaDDT.vue?vue&type=script&lang=js"
export * from "./listaDDT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports